import React, { useState, memo } from "react";
import { Dialog, Grid, TableContainer, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

import { Props } from "./interfaces";
import { StyledTable, DialogContent } from "./styles";
import DialogTitle from "../../../../DialogTitle/DialogTitle";
import OverlappingAbsencesTableHeader from "./OverlappingAbsencesTableHeader/OverlappingAbsencesTableHeader";
import OverlappingAbsencesTableBody from "./OverlappingAbsencesTableBody/OverlappingAbsencesTableBody";

const OverlappingAbsences = ({ absences }: Props) => {
  const theme = useTheme();

  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <Grid
        sx={{
          display: "flex",
          alignItems: "center",

          ...(!!absences.length && {
            "&:hover p": {
              cursor: "pointer",
            },
          }),
        }}
        onClick={() => absences.length && setOpen(true)}
      >
        <Typography>{absences.length}</Typography>
      </Grid>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle
          title={`Overlapping absences`}
          handleClose={() => setOpen(false)}
        />

        <DialogContent>
          <Grid sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "20px" }}>
            <Grid>
              <Link
                to={"/my-team-presence-and-leaves?tab=calendar"}
                style={{
                  color: theme.palette.primary.main,
                }}
              >{`See team calendar`}</Link>
            </Grid>

            <Grid sx={{ width: "100%", height: "60vh", display: "flex", alignItems: "center" }}>
              {!!absences.length && (
                <TableContainer sx={{ height: `100%`, width: "100%", overflow: "auto" }}>
                  <StyledTable stickyHeader>
                    <OverlappingAbsencesTableHeader />

                    <OverlappingAbsencesTableBody absences={absences} />
                  </StyledTable>
                </TableContainer>
              )}

              {!absences.length && <Typography>No items</Typography>}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default memo(OverlappingAbsences);
